import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'react-bootstrap'

import ModalCreateUpdate from 'pages/admin/taskCategories/ModalCreateUpdate'
import DeleteModal from 'pages/parts/DeleteModal'

import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'

function getDefaultItem() {
	return { 'code': '', 'name': '', 'sort_order': 0, 'status': 1 }
}

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [selectedItem, setSelectedItem] = useState(getDefaultItem())
	const [modalCreateUpdate, setModalCreateUpdate] = useState(false)
	const [modalDelete, setModalDelete] = useState(false)

	async function searchWithFilter() {
		const response = await GET('/admin/task-categories', {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data?.data || response.data || [])
		}
	}

	function toggleModalCreateUpdate(bool = false, item = getDefaultItem()) {
		setSelectedItem({ ...getDefaultItem(), ...item })
		setModalCreateUpdate(bool)
	}

	function toggleModalDelete(bool = false, item = getDefaultItem()) {
		setSelectedItem({ ...getDefaultItem(), ...item })
		setModalDelete(bool)
	}

	async function createUpdate(e) {
		e.preventDefault()

		var payload = {
			'code': selectedItem.code,
			'name': selectedItem.name,
			'sort_order': Number(selectedItem.sort_order) || 0,
			'status': Number(selectedItem.status),
		}

		var response
		if (!selectedItem.id) {
			response = await POST('/admin/task-categories', payload, { loader: true })
		} else {
			response = await PUT('/admin/task-categories', { ...payload, 'id': selectedItem.id }, { loader: true })
		}

		if (httpOk(response)) {
			toggleModalCreateUpdate()
			searchWithFilter()
		}
	}

	async function deleteItem() {
		const response = await DELETE(`/admin/task-categories/${selectedItem.id}`, {}, { loader: true })

		if (httpOk(response)) {
			toggleModalDelete()
			searchWithFilter()
		}
	}

	function returnDeleteMessage() {
		if (selectedItem.tasks_count > 0) {
			return `${t('task_category_has_tasks')}: ${selectedItem.tasks_count}. ${t('are_you_sure_you_want_delete')}`
		}
		return t('are_you_sure_you_want_delete')
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<div className="vertical-center">
					<h4>{t('task_categories')} [{data.length}]</h4>
				</div>
				<button className="btn-rounded btn btn-primary" onClick={() => toggleModalCreateUpdate(true)}>
					{t('create')}
				</button>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive" style={{ 'minHeight': '500px' }}>
						<table className="table table-bordered table-hover mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('code')}</th>
									<th style={{ 'width': '45%' }}>{t('name2')}</th>
									<th style={{ 'minWidth': '110px' }} className="text-center">{t('sort_order')}</th>
									<th style={{ 'minWidth': '90px' }} className="text-center">{t('tasks')}</th>
									<th style={{ 'minWidth': '110px' }} className="text-center">{t('status')}</th>
									<th style={{ 'minWidth': '33px' }} className="text-end"></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={item.id}>
										<td className="text-center">{index + 1}</td>
										<td>{item.code}</td>
										<td className="td-ellipsis" title={item.name}>{item.name}</td>
										<td className="text-center">{item.sort_order ?? 0}</td>
										<td className="text-center">{item.tasks_count ?? 0}</td>
										<td className="text-center">
											{Number(item.status) === 1 ? t('active') : t('not_active')}
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModalCreateUpdate(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
														<div className="table-dropdown-item text-danger"
															onClick={() => toggleModalDelete(true, item)}>
															<i className="uil-trash-alt"></i>
															{t('delete')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
								{data.length === 0 &&
									<tr>
										<td colSpan={7} className="text-center text-muted py-4">{t('list_empty')}</td>
									</tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{modalCreateUpdate &&
				<ModalCreateUpdate
					selectedItem={selectedItem}
					setSelectedItem={setSelectedItem}
					createUpdate={createUpdate}
					modalCreateUpdate={modalCreateUpdate}
					toggleModalCreateUpdate={toggleModalCreateUpdate}>
				</ModalCreateUpdate>
			}

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}
				message={returnDeleteMessage()}>
			</DeleteModal>
		</>
	)
}

export default Index
